import {
    initializeObservability,
    OBSERVABILITY_FALLBACKS,
    type ObservabilityClientConfig,
    type TransportItem
} from '@hello-aria/observability/client'
import { scrubTokenFromUrl } from '@/shared/utils/urlUtils'

const AMPLITUDE_LOGGER = 'Amplitude Logger'

function dropAmplitudeErrors(item: TransportItem): TransportItem | null {
    const payload = item.payload
    if (payload && typeof payload === 'object') {
        if ('message' in payload && typeof payload.message === 'string') {
            if (payload.message.includes(AMPLITUDE_LOGGER)) return null
        }
        if ('value' in payload && typeof payload.value === 'string') {
            if (payload.value.includes(AMPLITUDE_LOGGER)) return null
        }
    }
    return item
}

function scrubPortalToken(item: TransportItem): TransportItem {
    const pageUrl = item.meta.page?.url
    if (!pageUrl?.includes('token=')) return item
    return {
        ...item,
        meta: { ...item.meta, page: { ...item.meta.page, url: scrubTokenFromUrl(pageUrl) } }
    }
}

export function filterTransportItems(item: TransportItem): TransportItem | null {
    if (dropAmplitudeErrors(item) === null) return null
    return scrubPortalToken(item)
}

export const observabilityConfig: ObservabilityClientConfig = {
    collectorUrl: process.env.NEXT_PUBLIC_FARO_URL ?? '',
    app: {
        name: 'ClientPortal',
        version: process.env.NEXT_PUBLIC_APP_VERSION ?? OBSERVABILITY_FALLBACKS.version,
        environment: process.env.NEXT_PUBLIC_ENVIRONMENT ?? OBSERVABILITY_FALLBACKS.environment,
        namespace: process.env.NEXT_PUBLIC_FARO_APP_NAMESPACE ?? OBSERVABILITY_FALLBACKS.namespace
    },
    beforeSend: filterTransportItems
}

/**
 * Starts Faro with this app's config.
 *
 * ARCH-13: `instrumentation-client.ts` calls this rather than the package, so
 * the collector config has one reader. The package skips a start with no
 * collector URL, which is how a local run and a preview behave.
 */
export const startObservability = () => initializeObservability(observabilityConfig)
